import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        currentUser: null,
        // Global Dialog
        appProgressMessage: 'Autenticando...',
        appProgressDialog: false,

    },
    mutations: {
        showGlobalDialog(state, dialogData) {
            state.appProgressMessage = dialogData
            state.appProgressDialog = true
        },
        hideGlobalDialog(state) {
            state.appProgressDialog = false
        },
        changeAuth(state, authData) {
            state.currentUser = authData
        }
    },
    actions: {
        SHOW_GLOBAL_PROGRESS_DIALOG(context, dialogData) {
            context.commit('showGlobalDialog', dialogData)
        },
        HIDE_GLOBAL_PROGRESS_DIALOG(context, dialogData) {
            context.commit('hideGlobalDialog', dialogData)
        },
        AUTH_USER(context, authData) {
            context.commit('changeAuth', authData)
        }
    },
    modules: {
    }
})
